<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'app-page': isAppPage }]">
    <div>
      <a href="https://api.whatsapp.com/send/?phone=593992636662 " target="_blank" class="whatsapp-icon">
        <img src="/whatsapp.png" alt="WhatsApp" class="imagen-whatsapp">
      </a>
    </div>
    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal'">
        <!-- Navbar -->
        <div class="vx-navbar-wrapper nav-menu-wrapper" style="top: 0px; background: rgb(13, 135, 59); height: auto;">
          <header class="vs-navbar vx-navbar navbar-custom navbar-skelton vs-navbar-null vs-navbar-color-#fff"
            align="rigth" style="background: rgb(13, 135, 59); width: auto; float: right; height: 40px;">
            <div class="vs-navbar--header"><button class="vs-navbar--btn-responsive"><span
                  class="btn-responsive-line line--1"></span><span class="btn-responsive-line line--2"></span><span
                  class="btn-responsive-line line--3"></span></button></div>
            <div class="vs-con-items">
              <vs-button color="primary" size="small" icon="menu" @click="modalMenu = true"></vs-button>
              <ul class="menu-items flex flex-wrap w-full items-center">
                <li class="menu-item mr-2">
                  <div class="menu-link" v-show="!statusOnline">
                    <div class="h-nav-menu-item relative py-4 cursor-pointer"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      <template v-if="activeBloq">
                          <vs-button color="primary" size="small" icon="person" @click="viewPoupSession()">Iniciar Sesión</vs-button>
                      </template>
                      <template v-else>
                        <router-link tag="div" v-bind:to="'/account/login'"
                        style="float:left; margin-left: 5%; width:100%;">
                        <vs-button color="primary" size="small" icon="person">Iniciar Sesión</vs-button>
                        </router-link>
                      </template>                      
                    </div>
                  </div>
                  <div class="menu-link" v-show="statusOnline">
                    <div class="h-nav-menu-item relative py-4 cursor-pointer"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      <router-link tag="div" v-bind:to="'/'" style="float:left; margin-left: 5%; width:100%;">
                        <span style="color:#fff; font-weight:500;">
                          BIENVENIDO {{ (activeUserInfo == null ? '' : (activeUserInfo.apellidos)) }}
                        </span>
                      </router-link>
                    </div>
                  </div>
                </li>
                <span style="color:#fff; font-weight:500;" v-show="!statusOnline">|</span>
                <li class="menu-item mr-2">
                  <div class="menu-link" v-show="!statusOnline">
                    <div class="h-nav-menu-item relative py-4 cursor-pointer"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      <router-link tag="div" v-bind:to="'/account/register'"
                        style="float:left; margin-left: 5%; width:100%;">
                        <vs-button color="primary" size="small" icon="person_add">Registrarse</vs-button>
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </header>
        </div>
      </template>
      <div class="content-wrapper">
        <div class="router-view" style="padding-top: 0px;">
          <div class="router-content" style="margin-top: 5%;">
            <div class="content-area__content">
              <section id="ecommerce-header-navbar" class="seccion_verde">
                <the-navbar-horizontal style="top:10%;" :navbarType="navbarType" :logo="navMenuLogo" :class="[
                  { 'text-white': isNavbarDark && !isThemeDark },
                  { 'text-base': !isNavbarDark && isThemeDark }
                ]" />
              </section>
              <div class="sidebar-detached sidebar-left" style="padding-top:80px; padding-bottom:5%;">
                <div class="sidebar">
                  <div class="sidebar-shop" id="ecommerce-sidebar-toggler">
                    <div class="card" v-show="statusOnline">
                      <div class="card-body" style="padding:0px !important;">
                        <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                          <h6 class="filter-title mb-1 default"
                            style="color: white;font-size: 20px; border-bottom: none !important;">OPCIONES</h6>
                        </div>
                        <div id="product-categories">
                          <div class="product-category-title">
                          </div>
                          <ul class="list-unstyled categories-list">
                            <router-link tag="div" class="route" :to="option.url" v-bind:key="index"
                              v-for="(option, index) in navbarAdminList.data">
                              <li class="default" @click="estadoOpciones(option)">
                                <span class="vs-radio-con vs-radio-primary py-25">
                                  <span class="ml-50" v-text="option.label" @click="estadoOpciones(option)"
                                    style="padding-bottom:10px; padding-top:10px; text-transform:uppercase !important"></span>
                                </span>
                              </li>
                            </router-link>
                          </ul>
                        </div>
                        <hr>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body" style="padding:0px !important;">
                        <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                          <h6 class="filter-title mb-1 default"
                            style="color:white;font-size: 20px; border-bottom: none !important;">PRODUCTOS</h6>
                        </div>
                        <div id="product-categories">
                          <div class="product-category-title">
                          </div>
                          <ul class="list-unstyled categories-list">
                            <router-link tag="div" class="route" v-bind:key="index"
                              v-for="(category, index) in listClassificationProducts"
                              v-bind:to="'/list/shop-products/' + category.cod_clasificacion + '/' + null">
                              <li class="default" @click="estadoClasificacion(category)">
                                <span class="vs-radio-con vs-radio-primary py-25">
                                  <span class="ml-50" v-text="category.nombre_corto"
                                    style="padding-bottom:10px; padding-top:10px;"></span>
                                </span>
                              </li>
                            </router-link>
                          </ul>
                        </div>
                        <hr>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body" style="padding:0px !important;">
                        <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                          <router-link tag="div" class="route" to="/list/school-supplies">
                            <h6 class="filter-title mb-1 default"
                              style="color: white;font-size: 20px; border-bottom: none !important;">LISTA ÚTILES</h6>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div class="card" @click="documento">
                      <div class="card-body" style="padding:0px !important;">
                        <div class="div" style="background:rgb(13, 135, 59); height:70px;">
                          <h6 class="filter-title mb-1 default"
                            style="color: white;font-size: 20px; border-bottom: none !important;">FACTURACIÓN ELECTRÓNICA
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card" v-if="false">
                    <div class="card-body">
                      <div class="multi-range-price">
                        <div class="multi-range-title pb-75">
                          <h6 class="filter-title mb-0">CLASIFICACIÓN</h6>
                        </div>
                        <ul class="nav navbar-nav bookmark-icons"
                          style="border-bottom: 1px solid #BBBBBB; margin-left: 10px;">
                          <li class="nav-item d-none d-lg-block"
                            style="border-bottom: 1px solid #BBBBBB; margin-left: 10px;" v-bind:key="index"
                            v-for="(category, index) in listClassificationProducts">
                            <a class="nav-link " data-toggle="tooltip" data-placement="top"><i class="feather icon-home"
                                style="margin-right:5px;"></i><span class="menu-title"
                                v-text="category.nombre_corto"></span></a>
                          </li>
                        </ul>
                      </div>
                      <hr>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-detached content-right" style="padding-top:100px; padding-bottom:5%;">
                <div class="content-body">
                  <section id="ecommerce-header">
                    <div style="height: 62px" v-if="navbarType === 'static'"></div>
                    <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                      <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
                    </back-to-top>
                    <transition :name="routerTransition" mode="out-in">
                      <router-view @changeRouteTitle="changeRouteTitle"></router-view>
                    </transition>
                  </section>
                </div>
              </div>
              <vs-popup title="Mapgrafi informa" :active.sync="popupError">
                <p>Problemas de conexión, reinicie la página.
                  <br>
                </p>
                <div class="flex flex-wrap justify-center mb-3">
                  <vs-button color="primary" @click="procesoError()">Aceptar</vs-button>
                </div>
              </vs-popup>
              <vs-popup title="Mapgrafi informa" :active.sync="popupErrorSesion">
                <p>{{ messageSesion }}
                  <br>
                </p>
              </vs-popup>
              <vs-popup v-bind:title="'Mapgrafi informa'" :active.sync="modalMenu">
                <div class="card-body" style="padding:0px !important;" v-show="statusOnline">
                  <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                    <h6 class="filter-title mb-1 default"
                      style="color: white;font-size: 20px; border-bottom: none !important;">OPCIONES</h6>
                  </div>
                  <div id="product-categories">
                    <div class="product-category-title">
                    </div>
                    <ul class="list-unstyled categories-list">
                      <router-link tag="div" class="route" :to="option.url" v-bind:key="index"
                        v-for="(option, index) in navbarAdminList.data">
                        <li class="default" @click="estadoOpciones(option)">
                          <span class="vs-radio-con vs-radio-primary py-25">
                            <span class="ml-50" v-text="option.label" @click="estadoOpciones(option)"
                              style="padding-bottom:10px; padding-top:10px; text-transform:uppercase !important"></span>
                          </span>
                        </li>
                      </router-link>
                    </ul>
                  </div>
                </div>
                <div class="card-body" style="padding:0px !important;">
                  <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                    <h6 class="filter-title mb-1 default"
                      style="color: white;font-size: 20px; border-bottom: none !important;">PRODUCTOS</h6>
                  </div>
                  <div id="product-categories">
                    <ul class="list-unstyled categories-list">
                      <router-link tag="div" class="route" v-bind:key="index"
                        v-for="(category, index) in listClassificationProducts"
                        v-bind:to="'/list/shop-products/' + category.cod_clasificacion + '/' + null">
                        <li class="default" @click="estadoClasificacion(category)">
                          <span class="vs-radio-con vs-radio-primary py-25">
                            <span class="ml-50" v-text="category.nombre_corto"
                              style="padding-bottom:10px; padding-top:10px;"></span>
                          </span>
                        </li>
                      </router-link>
                    </ul>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body" style="padding:0px !important;">
                    <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                      <router-link tag="div" class="route" to="/list/school-supplies">
                        <h6 class="filter-title mb-1 default"
                          style="color: white;font-size: 20px; border-bottom: none !important;">LISTA ÚTILES</h6>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="card-body" style="padding:0px !important;" @click="documento">
                  <div class="div" style="background:rgb(13, 135, 59); height:50px;">
                    <h6 class="filter-title mb-1 default"
                      style="color: white;font-size: 20px; border-bottom: none !important;">FACTURACIÓN ELECTRÓNICA</h6>
                  </div>
                </div>
                <div class="flex flex-wrap justify-center mb-3 mt-5">
                  <vs-button color="danger" @click="(modalMenu = !modalMenu)">Salir</vs-button>
                </div>
              </vs-popup>
            </div>
          </div>
        </div>
        <the-footer />
      </div>
    </div>
  </div>
</template>



<script>
import BackToTop from 'vue-backtotop'
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour
  },
  data() {
    return {
      modalMenu: false,
      popupError: false,
      activeBloq: false,
      popupErrorSesion: false,
      messageSesion: null,
      navbarAdminList: this.$store.state.navbarAdminList,
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems: navMenuItems,
      navMenuLogo: require('@/assets/images/logo/logo.png'),
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      listClassificationProducts: [],
      valueCheckoutCategory: null,
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    },
    windowWidth(val) {
      if (val < 1200) this.disableThemeTour = true
    },
    verticalNavMenuWidth() {
      this.disableThemeTour = true
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    user_stateValue() {
      return this.activeUserInfo.statusValue
    },
    statusOnline() {
      return this.$store.state.AppActiveUser.status;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.path.includes('/apps/') ? true : false
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark'
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    documento() {
      window.open('http://facturacion.viadoc.com.ec/index_mapgrafi.php');
    },
    procesoError() {
      this.popupError = !this.popupError;
      location.reload();
    },
    cargaGeneralTipoDireccion() {
      this.$http.get(this.$store.state.domain + `mapgrafi/mapgrafi-general/tipo-direccion-carga-general/${process.env.VUE_APP_COD_EMPRESA_ERP}`)
        .then((response) => {
          if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
          else if (response.data.existeError) throw response.data.mensaje;
          else {
            localStorage.setItem('list_direcciones', JSON.stringify(response.data.data));
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 8000,
            title: 'Mapgrafi informa',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });
        })
    },
    clearSelector() {
      _.forEach(this.listClassificationProducts, function (clasi) {
        clasi.active = false;
      });
      _.forEach(this.navbarAdminList.data, function (clasi) {
        clasi.active = false;
      });
    },
    estadoClasificacion(clasificacion) {
      this.$store.dispatch('eCommerce/agregarClasificacion', clasificacion).then((response) => {
        if (this.$root.EcommerceShop) {
          this.$root.EcommerceShop.validaFechaPreventa();
        }
        _.forEach(this.listClassificationProducts, function (clasi) {
          clasi.active = false;
        });
        clasificacion.active = !clasificacion.active;
      });

    },
    estadoOpciones(clasificacion) {
      // _.forEach(this.navbarAdminList.data, function (clasi) {
      //   clasi.active = false;
      // });
      // clasificacion.active = !clasificacion.active;
    },

    loadGeneralClassification() {

      // var clasificaciones = new Promise((resolve,reject)=>{
      //    this.$http.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/producto-carga-general/C`)
      //       .then((response) => {
      //         resolve(response.data.data)
      //       });
      // });
      // clasificaciones.then((resolve)=>{
      //     this.$http.post(this.$store.state.domain+`mapgrafi/ecommerce/producto`, {
      //       data: {
      //         method: "clasificacion-carga-general",
      //         cod_clasificacion:null
      //       }
      //     })
      //     .then((response) => {
      //       if (response.status != 200) throw ('SERVIDOR NO RESPONDE');
      //       else if (response.data.existeError) throw(response.data.mensaje);
      //       else {
      //         console.log(response);
      //         this.listClassificationProducts = response.data.data;
      //         _.remove(this.listClassificationProducts, function(o) {
      //           var validar_existencia = 0;
      //             _.forEach(resolve,(i)=>{
      //               if(o.cod_clasificacion == i.id_cod_clasificacion){
      //                 validar_existencia++
      //               }
      //             });
      //             if(validar_existencia == 0){
      //               return true;
      //             }
      //             else{
      //               return false;
      //             }
      //         });
      //       }
      //     })
      //     .catch((error)=>{
      //       this.popupError = true;
      //     })
      // });
    },
    cargaGeneralEcommerce() {
      axios.post(this.$store.state.domain + `mapgrafi/ecommerce/ecommerce-carga-general`, {
        cod_empresa: process.env.VUE_APP_COD_EMPRESA_ERP
      })
        .then((response) => {
          if (response.status != 200) throw ('SERVIDOR NO RESPONDE');
          else if (response.data.existeError) throw (response.data.mensaje);
          else {
            localStorage.removeItem('date_pre_sale');
            localStorage.removeItem('discount_post');
            localStorage.removeItem('porcion');
            localStorage.removeItem('iva');
            localStorage.removeItem('id_transporte');
            localStorage.removeItem('tipo_transporte');
            localStorage.removeItem('leyenda_orden_venta');
            localStorage.removeItem('incluye_transporte');
            localStorage.removeItem('transporte');
            localStorage.removeItem('leyenda_orden_venta');
            localStorage.removeItem('tipoEntrega');
            localStorage.setItem('date_pre_sale', JSON.stringify(response.data.data['fecha_preventa']));
            localStorage.setItem('discount_post', JSON.stringify(response.data.data['porcentaje']));
            localStorage.setItem('porcion', JSON.stringify(response.data.data['porcion']));
            localStorage.setItem('iva', JSON.stringify(response.data.data['iva']));
            localStorage.setItem('tipoEntrega', JSON.stringify(response.data.data['tipoEntrega']));
            localStorage.setItem('incluye_transporte', JSON.stringify(response.data.data['incluyeTranspote']));
            localStorage.setItem('transporte', JSON.stringify(response.data.data['productoTransporte']));
            // localStorage.setItem('id_transporte',JSON.stringify(response.data.data['transporte']['val_parametro']));
            // localStorage.setItem('tipo_transporte',JSON.stringify(response.data.data['transporte']['txt_parametro']));
            localStorage.setItem('leyenda_preventa', JSON.stringify(response.data.data['leyenda'].leyenda_preventa));
            localStorage.setItem('leyenda_sin_preventa', JSON.stringify(response.data.data['leyenda'].leyenda_sin_preventa));

            this.listClassificationProducts = response.data.data['listadoClasificacion'];
            _.remove(this.listClassificationProducts, function (i) {
              var validar_existencia = 0;
              _.forEach(response.data.data['listadoClasificacionExistente'], (o) => {
                if (o.cod_clasificacion == i.cod_clasificacion) {
                  validar_existencia++
                }
              });
              if (validar_existencia == 0) {
                return true;
              }
              else {
                return false;
              }
            });
            this.validaFechaPreventa();
          }
        })
        .catch((error) => {
          this.popupError = true;
        })
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor("#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this
        .windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    clearFilter() {
      this.valueCheckoutCategory = null;
    },
    validaFechaPreventa() {
      var fecha_preventa = JSON.parse(localStorage.getItem('date_pre_sale'));
      var statusPreventa = true;
      let obtenerFechaActual = new Promise((resolve, reject) => {
        axios.get(this.$store.state.domain + `mapgrafi/mapgrafi-general/obtener-fecha`)
          .then((response) => {
            resolve(response);
          }).catch((error) => {
            console.error(error);
          })
      });
      obtenerFechaActual.then((response) => {
        console.log(response.data, fecha_preventa.fechaDesde, fecha_preventa.fechaHasta );
        statusPreventa = moment(response.data).isBetween(fecha_preventa.fechaDesde, fecha_preventa.fechaHasta); //truereturn true
        localStorage.removeItem('statusPreventa');
        console.log("Estado preventa en validaFechaPreventa 570");
        localStorage.setItem('statusPreventa', JSON.stringify(statusPreventa));
      });
      // this.$store.dispatch('statusPreventa', statusPreventa)
    },

    sesionBloq() {
      axios.get(this.$store.state.domain + `mapgrafi/seguridad/bloquear-inicio-sesion/${process.env.VUE_APP_COD_EMPRESA_ERP}`).then((response) => {
        if (response.status != 200) throw ('SERVIDOR NO RESPONDE');
        const { existeError, mensaje, data } = response.data;
        if (existeError) throw (mensaje);
        else { 
          this.activeBloq = data.bloquearSesion;
          localStorage.setItem('bloquearSesion', data.bloquearSesion);
          localStorage.setItem('mensajeSesion', data.mensaje);
        }
      })
    }, 

    viewPoupSession() {
      const valueBloqueo = localStorage.getItem('bloquearSesion').toLowerCase();
      this.popupErrorSesion = valueBloqueo == "true";
      this.messageSesion = localStorage.getItem('mensajeSesion');
    }
  },
  created() {
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.$store.dispatch('eCommerce/storeItems')
    this.loadGeneralClassification();
    this.clearSelector();
    this.cargaGeneralEcommerce();
    this.cargaGeneralTipoDireccion();
    this.sesionBloq();
  },
}

</script>

<style>
.imagen-whatsapp {
  height: 70px;
}
.whatsapp-icon {
      position: fixed;
      bottom: 10vh; /* Ajusta la posición vertical según tus necesidades */
      right: 20px; /* Ajusta la posición horizontal según tus necesidades */
      z-index: 1000; /* Asegura que esté sobre otros elementos */
      
}
.navbarCustom {
  position: fixed;
  top: 0%;
  width: 100%;
  height: 40px;
  position: fixed;
  margin: 0px;
  z-index: 4000;
  padding: 20px 0px 10px;
  background: rgb(13, 135, 59);
  top: 0px;
  left: 0px;
}

li .default:hover {
  background-color: transparent !important;
}

.default {
  display: block;
  color: #000;
  padding: 8px 16px;
  text-decoration: none;
  text-transform: capitalize !important;
  border-bottom: 2px solid #f3f3f3;
  cursor: pointer;
}

.default:hover {
  background: rgb(49, 167, 94) !important;
  color: white !important;
}

.default:active {
  background: rgb(49, 167, 94) !important;
  color: white !important;
}

.seccion_verde {
  position: fixed;
  margin-left: -260px;
  z-index: 4000;
  margin: 0px;
  padding: 20px 0px 10px 0px;
  width: 100%;
  height: auto;
  background: #f4f4f4;
  top: 40px;
  left: 0px;
}

@media screen and (max-width: 600px) {
  .seccion_verde {
    position: fixed;
    margin-left: -260px;
    z-index: 4000;
    margin: 0px;
    padding: 20px 0px 10px 0px;
    width: 100%;
    height: 15%;
    background: #f4f4f4;
    top: 40px;
    left: 0px;
  }

}</style>
